// Video slider pause on homepage
jQuery(document).ready(function() {
  var currentVideo = null;
  
  jQuery('video').on('play', function() {
    if (currentVideo !== null && currentVideo.get(0) !== this) {
      currentVideo.get(0).pause();
    }
    currentVideo = jQuery(this);
  });
  
  jQuery('video').on('ended', function() {
    currentVideo = null;
  });
});
// Video slider pause on homepage